import { render, staticRenderFns } from "./ShowMasterGoal.vue?vue&type=template&id=de465cb8&"
import script from "./ShowMasterGoal.vue?vue&type=script&lang=js&"
export * from "./ShowMasterGoal.vue?vue&type=script&lang=js&"
import style0 from "./ShowMasterGoal.vue?vue&type=style&index=0&id=de465cb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports